export const lineStyle = {
  backgroundColor: '#E2E7F1',
  boxShadow: '0 0.4rem 1.5rem rgba(0, 0, 0, 0.15)',
};

export const buttonStyle = {
  gap: 0,
  width: '2.4rem',
  height: '2.4rem',
  border: 'none',
  backgroundColor: '#E2E8F0',
  boxShadow: '0 0.4rem 1.5rem rgba(0, 0, 0, 0.15)',
  color: '#0056FF',
};
